/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import CurrencyInput from "react-currency-input-field";
import DatePicker, { registerLocale } from "react-datepicker";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import WhatsappNumberInput from "../core/components/whatsapp-number-input/WhatsappNumberInput";
import CustomNumberInput from "../core/components/custom-number-input/CustomNumberInput";
import {
  getUserDataFromLocalStorage,
  isValidAgeNextBirthdayWithTerm,
  isValidNic,
  getDate_ddmmyyyy,
  canModifyQuotation,
} from "../core/utils";
import { IoCheckmark } from "react-icons/io5";
import { PlusIcon } from "lucide-react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import "react-datepicker/dist/react-datepicker.css";
import uk from "date-fns/locale/en-GB";
import GoBack from "../core/components/goBack";
import apiRoutes from "../api/apiRoutes";
import { useParams } from "react-router-dom";
// import PhoneInput from "react-phone-number-input";
registerLocale("uk", uk);

const FlexiEditQuotation = () => {
  // eslint-disable-next-line no-unused-vars

  const params = useParams();

  const { userData, setUserData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const navigate = useNavigate();
  const whatsappNumberRef = useRef();
  const bankRepContactRef = useRef();
  const jointLifephoneNumberRef = useRef();
  const phoneNumberRef = useRef();
  const [bankBranches, setBankBranches] = useState([]);
  const [quotation, setQuotation] = useState([]);
  const [authorized, setAuthorized] = useState();
  const [pepQuestions, setPepQuestions] = useState([]);
  const [fatcaQuestions, setFatcaQuestions] = useState([]);
  const [pepQuestionsJoint, setPepQuestionsJoint] = useState([]);
  const [fatcaQuestionsJoint, setFatcaQuestionsJoint] = useState([]);
  const [state, setState] = useState({
    title: "",
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    birth: "",
    nic: "",
    maiden_name: "",
    passport_number: "",
    nationality: "",
    joint_user_title: "",
    joint_user_firstname: "",
    joint_user_lastname: "",
    joint_user_birth: null,
    joint_user_nic: "",
    joint_user_email: "",
    joint_user_phoneNumber: "",
    joint_user_maiden_name: "",
    joint_user_passport_number: "",
    joint_user_nationality: "",
    joint_user_relationship: "",
    intended_commencement_date: new Date(Moment().format("YYYY-MM-DD")),
    join_loan: false,
    term_number: "",
    initial_sum_assured: "",
    term_option: "years",
    gender: "",
    loan_type: "capital-interest",
    loan_plan: "",
    with_refund: false,
    with_tpd: true,
    bank_name: "",
    bank_branch: "",
    joint_user_financial_institution_branch: "",
    bank_rep_name: "",
    bank_rep_email: "",
    bank_rep_contact: "",
    consent_bank_rep: false,
  });

  const intendedCommencementDateRef = useRef();
  const birthRef = useRef();
  const otherBirthRef = useRef();
  const [banks, setBanks] = useState([]);
  const eighteenYearsAgo = Moment().subtract(18, "years").format("YYYY-MM-DD");
  const sixtyFiveYearsAgo = Moment().subtract(65, "years").format("YYYY-MM-DD");
  const fifteenDaysFromToday = Moment().add(15, "days").format("YYYY-MM-DD");
  const today = Moment().format("YYYY-MM-DD");
  const [errors, setErrors] = useState({
    title: null,
    name: null,
    email: null,
    nic: null,
    phoneNumber: null,
    birth: null,
    maiden_name: null,
    passport_number: null,
    nationality: null,
    joint_user_title: null,
    joint_user_name: null,
    joint_user_firstname: null,
    joint_user_lastname: null,
    joint_user_email: null,
    joint_user_nic: null,
    joint_user_gender: null,
    term_number: null,
    gender: null,
    initial_sum_assured: null,
    term_option: null,
    loan_type: null,
    loan_plan: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Beneficiary related state
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [beneficiaryErrors, setBeneficiaryErrors] = useState([]);
  const [activeBenefit, setActiveBenefit] = useState(null);

  const getQuotationDetails = async () => {
    setLoading(true);
    const id = params.id;
    const url = process.env.REACT_APP_API_URL + `/flexible-plan/${id}`;
    const userData = getUserDataFromLocalStorage();
    const userId = userData?.data?.id;

    try {
      const response = await axiosPrivate.get(url);
      if (response.data.success === true) {
        const _quotation = response.data.data;
        if (_quotation.quotationFormData) {
          _quotation.quotationFormData = JSON.parse(
            _quotation.quotationFormData
          );
        }

        if (
          !_quotation.beneficiaries &&
          _quotation.quotationFormData?.beneficiaries
        ) {
          _quotation.beneficiaries = _quotation.quotationFormData.beneficiaries;
        }

        setQuotation(_quotation);
        setAuthorized(canModifyQuotation(_quotation, userId));

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      throw new Error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      await getQuotationDetails();
      await getBanks();
      await getDeclarationQuestions();
    };

    fetchInitialData();
  }, []);

  const getDeclarationQuestions = async () => {
    const url = "/declaration/active";

    try {
      const response = await axiosPrivate.post(url, { active: true });

      setPepQuestions(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "PEP")
      );
      setPepQuestionsJoint(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "PEP")
      );
      setFatcaQuestions(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "FATCA")
      );
      setFatcaQuestionsJoint(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "FATCA")
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    //Pre-populating from userData

    // getQuotationDetails();
    // const userDetails = getUserDataFromLocalStorage();

    if (quotation?.quotationFormData && banks.length) {
      const title = quotation?.quotationFormData?.main_user_title
        ? quotation?.quotationFormData?.main_user_title
        : "";
      const name = quotation?.quotationFormData?.main_user_name
        ? quotation?.quotationFormData?.main_user_name
        : "";
      const phoneNumber = quotation?.quotationFormData?.main_user_phoneNumber
        ? quotation?.quotationFormData?.main_user_phoneNumber
        : "";
      const whatsappNumber = quotation?.quotationFormData
        ?.main_user_whatsappNumber
        ? quotation?.quotationFormData?.main_user_whatsappNumber
        : phoneNumber;
      const firstname = name.includes(" ")
        ? name.split(" ").slice(0, -1).join(" ")
        : "";
      const lastname = name.includes(" ")
        ? name.split(" ").slice(-1).join(" ")
        : "";

      const birth = quotation?.quotationFormData?.main_user_birth
        ? new Date(Moment(quotation?.quotationFormData?.main_user_birth))
        : null;
      const nic = quotation?.quotationFormData?.main_user_nic
        ? quotation?.quotationFormData?.main_user_nic
        : "";
      const gender = quotation?.quotationFormData?.main_user_gender
        ? quotation?.quotationFormData?.main_user_gender
        : "";
      const email = quotation?.quotationFormData?.main_user_email
        ? quotation?.quotationFormData?.main_user_email
        : "";
      const maiden_name = quotation?.quotationFormData?.main_user_maiden_name
        ? quotation?.quotationFormData?.main_user_maiden_name
        : "";
      const passport_number = quotation?.quotationFormData
        ?.main_user_passport_number
        ? quotation?.quotationFormData?.main_user_passport_number
        : "";
      const nationality = quotation?.quotationFormData?.main_user_nationality
        ? quotation?.quotationFormData?.main_user_nationality
        : "";

      const initial_sum_assured = quotation?.quotationFormData
        ?.initial_sum_assured
        ? quotation?.quotationFormData?.initial_sum_assured
        : "";
      const bank_name = quotation?.quotationFormData?.bank_name
        ? quotation?.quotationFormData?.bank_name
        : "";

      const bank_branch = quotation?.quotationFormData?.bank_branch_name
        ? quotation?.quotationFormData?.bank_branch_name
        : "";

      if (bank_name && banks.length) {
        const branches = getBranchesForBank(bank_name);
        setBankBranches(branches);

        if (state.bank_name !== bank_name) {
          setState((prev) => ({ ...prev, bank_name }));
        }

        if (
          bank_branch &&
          branches.some(
            (b) =>
              `${b.name}, ${b.town}` === bank_branch ||
              `${b.name} - ${b.town}` === bank_branch
          )
        ) {
          setState((prev) => ({ ...prev, bank_branch }));
        }
      }

      const bank_rep_name = quotation?.quotationFormData?.bank_rep_name
        ? quotation?.quotationFormData?.bank_rep_name
        : "";
      const bank_rep_email = quotation?.quotationFormData?.bank_rep_email
        ? quotation?.quotationFormData?.bank_rep_email
        : "";
      const bank_rep_contact = quotation?.quotationFormData?.bank_rep_contact
        ? quotation?.quotationFormData?.bank_rep_contact
        : "";
      const join_loan = quotation?.quotationFormData?.join_loan
        ? quotation?.quotationFormData?.join_loan
        : "";

      console.log("jl", join_loan);
      const consent_bank_rep = quotation?.quotationFormData?.consent_bank_rep
        ? quotation?.quotationFormData?.consent_bank_rep
        : "";

      setState({
        ...state,
        title,
        firstname,
        lastname,
        maiden_name,
        passport_number,
        nationality,
        birth,
        nic: nic,
        gender,
        phoneNumber,
        whatsappNumber,
        email,
        join_loan,
        initial_sum_assured,
        bank_name,
        bank_branch: bank_branch,
        bank_rep_name,
        bank_rep_email,
        bank_rep_contact,
        consent_bank_rep,
      });
    } else if (quotation?.joinLoan) {
      // const quotation?.quotationFormData = response.data.data;
      const joint_user_title = quotation?.quotationFormData?.joint_user_title
        ? quotation?.quotationFormData?.joint_user_title
        : "";
      const joint_name = quotation?.quotationFormData?.joint_user_name
        ? quotation?.quotationFormData?.joint_user_name
        : "";
      const joint_user_phoneNumber = quotation?.quotationFormData
        ?.joint_user_phoneNumber
        ? quotation?.quotationFormData?.joint_user_phoneNumber
        : "";
      // const firstname = name.includes(" ") ? name.split(" ")[0] : "";
      // const lastname = name.includes(" ") ? name.split(" ")[1] : "";

      const joint_user_firstname = joint_name.includes(" ")
        ? joint_name.split(" ").slice(0, -1).join(" ")
        : "";
      const joint_user_lastname = joint_name.includes(" ")
        ? joint_name.split(" ").slice(-1).join(" ")
        : "";

      const joint_user_birth = quotation?.quotationFormData?.joint_user_birth
        ? new Date(
            Moment(quotation?.quotationFormData?.joint_user_birth).format(
              "YYYY-MM-DD"
            )
          )
        : null;
      const joint_user_email = quotation?.quotationFormData?.joint_user_email
        ? quotation?.quotationFormData?.joint_user_email
        : "";
      const joint_user_nic = quotation?.quotationFormData?.joint_user_nic
        ? quotation?.quotationFormData?.joint_user_nic
        : "";
      const joint_user_gender = quotation?.quotationFormData?.joint_user_gender
        ? quotation?.quotationFormData?.joint_user_gender
        : "";
      const joint_user_whatsappNumber = quotation?.quotationFormData
        ?.joint_user_whatsappNumber
        ? quotation?.quotationFormData?.joint_user_whatsappNumber
        : null;

      setState({
        ...state,
        joint_user_firstname,
        joint_user_lastname,
        joint_user_phoneNumber,
        joint_user_nic,
        joint_user_birth,
        joint_user_email,
        joint_user_title,
        joint_user_gender,
        joint_user_whatsappNumber,
        userJointId: quotation?.quotationFormData?.userJointId,
        joint_user_maiden_name:
          quotation?.quotationFormData?.joint_user_maiden_name,
        joint_user_passport_number:
          quotation?.quotationFormData?.joint_user_passport_number,
        joint_user_nationality:
          quotation?.quotationFormData?.joint_user_nationality,
        joint_user_relationship:
          quotation?.quotationFormData?.joint_user_relationship,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotation, banks]);

  // Initialize beneficiaries from quotation data
  useEffect(() => {
    if (
      quotation?.quotationFormData?.beneficiaries ||
      quotation?.beneficiaries
    ) {
      const beneficiariesData =
        quotation?.quotationFormData?.beneficiaries || quotation?.beneficiaries;

      setBeneficiaries(
        beneficiariesData.map((b) => ({
          ...b,
          percentage:
            typeof b.percentage === "string"
              ? parseFloat(b.percentage)
              : b.percentage,
        }))
      );
      setBeneficiaryErrors(new Array(beneficiariesData.length).fill({}));
    }

    // Auto-set active benefit based on user's conditions
    const initialSumAssured = quotation?.quotationFormData?.initial_sum_assured;
    const bankName = quotation?.quotationFormData?.bank_name;
    const bankBranch = quotation?.quotationFormData?.bank_branch_name;
    const hasBeneficiaries =
      (quotation?.quotationFormData?.beneficiaries || quotation?.beneficiaries)
        ?.length > 0;

    // Check if bank data exists (for disabling beneficiary option)
    const hasBankData = initialSumAssured && bankName && bankBranch;

    // If neither bank data nor beneficiary data exists, enable both options
    if (hasBankData) {
      setActiveBenefit(1); // Auto-select bank section if complete bank data exists
    } else if (hasBeneficiaries) {
      setActiveBenefit(0); // Auto-select beneficiary section if beneficiaries exist
    } else {
      setActiveBenefit(null); // Fallback to both options enabled
    }
  }, [quotation]);

  // Beneficiary functions
  const addBeneficiary = () => {
    setBeneficiaries([
      ...beneficiaries,
      { fullname: "", percentage: "", nic: "", relationship: "" },
    ]);
    setBeneficiaryErrors([...beneficiaryErrors, {}]);
  };

  const removeBeneficiary = (index) => {
    const newBeneficiaries = beneficiaries.filter((_, i) => i !== index);
    const newErrors = beneficiaryErrors.filter((_, i) => i !== index);
    setBeneficiaries(newBeneficiaries);
    setBeneficiaryErrors(newErrors);
  };

  const handleBeneficiaryChange = (index, field, value) => {
    const newBeneficiaries = [...beneficiaries];
    // Convert to number if it's the percentage field
    newBeneficiaries[index][field] =
      field === "percentage" ? parseFloat(value) || 0 : value;
    setBeneficiaries(newBeneficiaries);

    // Clear error for this field
    const newErrors = [...beneficiaryErrors];
    if (newErrors[index]) {
      newErrors[index][field] = null;
      setBeneficiaryErrors(newErrors);
    }
  };

  const validateBeneficiaries = () => {
    const errors = [];
    let isValid = true;

    // Check if beneficiaries exist when activeBenefit is 0
    if (activeBenefit === 0 && beneficiaries.length === 0) {
      setError("At least one beneficiary is required");
      return false;
    }

    beneficiaries.forEach((beneficiary, index) => {
      const error = {};

      if (!beneficiary.fullname?.trim()) {
        error.fullname = "Full name is required";
        isValid = false;
      }

      if (!beneficiary.percentage || parseFloat(beneficiary.percentage) <= 0) {
        error.percentage = "Percentage must be greater than 0";
        isValid = false;
      }

      if (!beneficiary.relationship?.trim()) {
        error.relationship = "Relationship is required";
        isValid = false;
      }

      errors[index] = error;
    });

    // Check total percentage
    const total = totalAllocated;
    if (activeBenefit === 0 && total !== 100) {
      setError(
        `Total beneficiary percentage must equal 100%. Current total: ${total}%`
      );
      isValid = false;
    }

    setBeneficiaryErrors(errors);
    return isValid;
  };

  const totalAllocated = beneficiaries.reduce(
    (sum, beneficiary) => sum + (parseFloat(beneficiary.percentage) || 0),
    0
  );

  const handleAddBenefit = (id) => {
    if (
      id === 1 &&
      beneficiaries.some((b) => b.fullname && parseFloat(b.percentage) > 0)
    ) {
      setError("Cannot add bank details when beneficiaries exist");
      return;
    }

    if (id === 0 && (state.bank_name || state.bank_branch)) {
      setError("Cannot add beneficiaries when bank details exist");
      return;
    }

    setActiveBenefit((prev) => (prev === id ? null : id));
    setError(null);
  };

  const benefitsToggle = [
    {
      id: 0,
      title: "Add Beneficiary",
      icon: "/beneficiaryfamily.svg",
      content: "",
    },
    {
      id: 1,
      title: "Add Bank Details",
      icon: "/beneficiarybank.svg",
      content: "",
    },
  ];

  const getBanks = async () => {
    const url = process.env.REACT_APP_API_URL + `/bank`;

    const response = await axiosPrivate.get(url);

    if (response.data.success) {
      setBanks(response.data.data);
    }
  };

  const getBranchesForBank = (bankName) => {
    if (!banks.length) return [];
    const bank = banks.find((b) => b.name === bankName);

    return bank?.BranchBanks || bank?.branches || [];
  };

  const clearBankDetails = () => {
    setState((prev) => ({
      ...prev,
      initial_sum_assured: "",
      bank_name: "",
      bank_branch: "",
      joint_user_financial_institution_branch: "",
      bank_rep_name: "",
      bank_rep_email: "",
      bank_rep_contact: "",
    }));
    setErrors((prev) => ({
      ...prev,
      initial_sum_assured: null,
      bank_name: null,
      bank_branch: null,
    }));
  };

  const submitData = async () => {
    setErrors({
      title: null,
      name: null,
      firstname: null,
      lastname: null,
      email: null,
      nic: null,
      phoneNumber: null,
      birth: null,
      maiden_name: null,
      passport_number: null,
      nationality: null,
      joint_user_title: null,
      joint_user_name: null,
      joint_user_firstname: null,
      joint_user_lastname: null,
      joint_user_email: null,
      joint_user_gender: null,
      joint_user_nic: null,
      joint_user_maiden_name: null,
      joint_user_passport_number: null,
      joint_user_nationality: null,
      joint_user_relationship: null,
      term_number: null,
      gender: null,
      initial_sum_assured: null,
      term_option: null,
      loan_type: null,
      bank_name: null,
      bank_branch: null,
      loan_plan: null,
    });

    // Extra Frontend Validation
    if (state.title.trim().length === 0 || !state.title) {
      setErrors({ title: ["title is required"] });
      return;
    }

    if (state.firstname.trim().length === 0 || !state.firstname) {
      setErrors({ firstname: ["first names is required"] });
      return;
    }

    if (state.lastname.trim().length === 0 || !state.lastname) {
      setErrors({ lastname: ["last name is required"] });
      return;
    }

    if (
      !state.birth ||
      (typeof state.birth === "string" && state.birth.trim().length === 0)
    ) {
      setErrors({ birth: ["birthday is required"] });
      return;
    }

    //implement validation for passport_number
    if (
      !state.nationality ||
      (typeof state.nationality === "string" &&
        state.nationality.trim().length === 0)
    ) {
      setErrors({ nationality: ["Nationality is required"] });
      return;
    }

    // NEW VALIDATIONS
    if (
      !state.nic ||
      (typeof state.nic === "string" && state.nic.trim().length === 0)
    ) {
      setErrors({ nic: ["NIC is required"] });
      return;
    }

    if (state.nic.length === 0 || state.nic.length !== 14) {
      setErrors({ nic: ["The NIC number must be 14 characters"] });
      return;
    }

    if (!state.gender) {
      setErrors({ gender: ["gender is required"] });
      return;
    }
    //End of Extra Frontend Validation

    // Validate beneficiaries if beneficiary section is active
    if (activeBenefit === 0 && !validateBeneficiaries()) {
      return;
    }

    if (!state.join_loan) {
      const url = apiRoutes.createFlexiQuotation + `/${params?.id}`;

      //Term+ageNextBirthday Validation
      if (!isValidAgeNextBirthdayWithTerm(state.birth, state.term_number)) {
        setError(
          "Sum of age next birthday and term should not be more than 75!"
        );
        return;
      }

      if (state.nic.length === 0 || state.nic.length !== 14) {
        setErrors("The NIC number must be 14 characters");
        return;
      }

      if (!isValidNic(state.nic, state.birth)) {
        setError("The NIC number doesn't match with the birthday");
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const payload = {
          ...state,
          userId: null,
          userJointId: null,
          isNewJoint: false,
          main_user_title: state.title,
          main_user_name: state.firstname + " " + state.lastname,
          main_user_birth: getDate_ddmmyyyy(state.birth),
          main_user_nic: state.nic,
          main_user_gender: state.gender,
          main_user_maiden_name: state.maiden_name,
          main_user_phoneNumber: state.phoneNumber,
          main_user_whatsappNumber: state.whatsappNumber,
          main_user_email: state.email,
          main_user_passport_number: state.passport_number,
          main_user_nationality: state.nationality,
          savings_type: quotation?.savingsType,
          payment_insurance_plan: quotation?.paymentInsurancePlan,
          initial_sum_assured: state.initial_sum_assured || 100000,
          basic_contribution_amount:
            parseFloat(quotation?.basicContributionAmount) || 1000,
          single_contribution_amount:
            parseFloat(quotation?.singleContributionAmount) || 50000,
          intended_commencement_date: getDate_ddmmyyyy(
            state.intended_commencement_date
          ),
          branch_name: state.bank_branch,
          bank_branch_name: state.bank_branch,
          bank_rep_email: state.bank_rep_email,
          bank_rep_contact: state.bank_rep_contact,
          consent_bank_rep: state.consent_bank_rep,
          death_benefit: parseFloat(quotation?.deathBenefit) || 100000,
          tpd_benefit: parseFloat(quotation?.tpdBenefit) || 100000,
          beneficiaries:
            beneficiaries.length > 0
              ? beneficiaries
              : quotation?.quotationFormData?.beneficiaries ||
                quotation?.beneficiaries ||
                [],
        };

        delete payload.firstname;
        delete payload.lastname;
        delete payload.joint_user_title;
        delete payload.joint_user_firstname;
        delete payload.joint_user_lastname;
        delete payload.joint_user_birth;
        delete payload.joint_user_nic;
        delete payload.joint_user_email;
        delete payload.joint_user_phoneNumber;
        delete payload.joint_user_maiden_name;
        delete payload.joint_user_passport_number;
        delete payload.joint_user_nationality;
        delete payload.joint_user_relationship;

        // PROVISIONAL FIX
        // return console.log({payload});

        if (payload.bank_branch === "Other") {
          payload.bank_branch = payload.joint_user_financial_institution_branch;
          delete payload.joint_user_financial_institution_branch;
        }

        try {
          payload.initial_sum_assured = parseFloat(
            payload.initial_sum_assured.toString()
          );
        } catch (error) {
          console.log(error);
        }

        if (payload.beneficiaries && payload.beneficiaries.length > 0) {
          payload.beneficiaries = payload.beneficiaries.map((beneficiary) => ({
            ...beneficiary,
            percentage: parseFloat(beneficiary.percentage) || 0,
          }));
        }

        setLoading(true);

        const { data } = await axiosPrivate.patch(url, payload);

        setLoading(false);
        setErrors({
          title: null,
          name: null,
          firstname: null,
          lastname: null,
          email: null,
          nic: null,
          phoneNumber: null,
          birth: null,
          maiden_name: null,
          passport_number: null,
          nationality: null,
          joint_user_title: null,
          joint_user_name: null,
          joint_user_firstname: null,
          joint_user_lastname: null,
          joint_user_email: null,
          joint_user_nic: null,
          joint_user_maiden_name: null,
          joint_user_passport_number: null,
          joint_user_nationality: null,
          joint_user_relationship: null,
          term_number: null,
          gender: null,
          initial_sum_assured: null,
          term_option: null,
          loan_type: null,
          loan_plan: null,
          bank_branch: null,
        });
        if (data.success) {
          //show quotation
          if (data.success) {
            // Refresh quotation data after successful update
            await getQuotationDetails();
            alert("Quotation updated successfully!");
            navigate(`/quotations/${params.id}`);
          }
        } else {
          setError(
            data.message
              ? data.message
              : "Quotation generation was unsuccessful, please try again"
          );
        }
      } catch (error) {
        //Handing Form Errors
        setLoading(false);
        setError(null);

        if (
          error?.response?.data?.errors &&
          Object.keys(error?.response?.data?.errors).length > 0
        ) {
          const errorsFromServer = error.response.data.errors;
          console.error(errorsFromServer);
          let errorData = {};
          if (errorsFromServer.length > 0) {
            errorsFromServer.forEach((err) => {
              if (!errorData[err.field]) {
                errorData[err.field] = [];
              }
              errorData[err.field].push(err.message);
            });
          }
          setErrors(errorData);
        } else if (error?.response?.data?.message) {
          setError(error?.response?.data?.message);
        } else {
          setError("Quotation generation was unsuccessful, please try again");
        }
      }
    } else {
      const url =
        process.env.REACT_APP_API_URL +
        apiRoutes.createFlexiQuotation +
        `/${params?.id}`;

      try {
        // Extra Frontend Validation
        if (
          state.joint_user_title.trim().length === 0 ||
          !state.joint_user_title
        ) {
          setErrors({ joint_user_title: ["title is required"] });
          return;
        }

        if (
          state.joint_user_firstname.trim().length === 0 ||
          !state.joint_user_firstname
        ) {
          setErrors({ joint_user_firstname: ["first names is required"] });
          return;
        }

        if (
          state.joint_user_lastname.trim().length === 0 ||
          !state.joint_user_lastname
        ) {
          setErrors({ joint_user_lastname: ["last name is required"] });
          return;
        }

        if (
          !state.joint_user_birth ||
          (typeof state.joint_user_birth === "string" &&
            state.joint_user_birth.trim().length === 0)
        ) {
          setErrors({ joint_user_birth: ["birthday is required"] });
          return;
        }

        if (
          !state.joint_user_gender ||
          (typeof state.joint_user_gender === "string" &&
            state.joint_user_gender.trim().length === 0)
        ) {
          setErrors({ joint_user_gender: ["Gender is required"] });
          return;
        }
        if (
          !state.joint_user_nic ||
          (typeof state.joint_user_nic === "string" &&
            state.joint_user_nic.trim().length === 0)
        ) {
          setErrors({ joint_user_nic: ["NIC is required"] });
          return;
        }

        if (
          state.joint_user_nic.length === 0 ||
          state.joint_user_nic.length !== 14
        ) {
          setErrors({
            joint_user_nic: ["The NIC number must be 14 characters"],
          });
          return;
        }
        //End of Extra Frontend Validation

        // Validate beneficiaries if beneficiary section is active
        if (activeBenefit === 0 && !validateBeneficiaries()) {
          return;
        }

        //Term+ageNextBirthday Validation for main life
        if (!isValidAgeNextBirthdayWithTerm(state.birth, state.term_number)) {
          setError(
            "Sum of age next birthday for main life and term should not be more than 75!"
          );
          return;
        }

        //Term+ageNextBirthday Validation for joint life
        if (
          !isValidAgeNextBirthdayWithTerm(
            state.joint_user_birth,
            state.term_number
          )
        ) {
          setError(
            "Sum of age next birthday for joint life and term should not be more than 75!"
          );
          return;
        }

        if (state.nic.length === 0 || state.nic.length !== 14) {
          setError("The NIC number must be 14 characters");
          return;
        }

        if (!isValidNic(state.nic, state.birth)) {
          setError("The Main Life NIC number doesn't match with the birthday");
          return;
        }

        if (
          state.joint_user_nic.length === 0 ||
          state.joint_user_nic.length !== 14
        ) {
          setError("The joint life NIC number must be 14 characters");
          return;
        }

        if (!isValidNic(state.joint_user_nic, state.joint_user_birth)) {
          setError("The Joint Life NIC number doesn't match with the birthday");
          return;
        }

        const payload = {
          ...state,
          userId: null,
          userJointId: null,
          isNewJoint: false,
          main_user_name: state.firstname + " " + state.lastname,
          main_user_title: state.title,
          main_user_birth: state.birth,
          main_user_nic: state.nic,
          main_user_phoneNumber: state.phoneNumber,
          main_user_whatsappNumber: state.whatsappNumber,
          main_user_email: state.email,
          main_user_gender: state.gender,
          joint_user_title: state.joint_user_title,
          joint_user_name:
            state.joint_user_firstname + " " + state.joint_user_lastname,
          joint_user_birth: state.joint_user_birth,
          joint_user_nic: state.joint_user_nic,
          joint_user_gender: state.joint_user_gender,
          joint_user_phoneNumber: state.joint_user_phoneNumber,
          joint_user_whatsappNumber: state.joint_user_whatsappNumber,
          joint_user_email: state.joint_user_email,
          joint_user_maiden_name: state.maiden_name,
          joint_user_passport_number: state.passport_number,
          joint_user_nationality: state.nationality,
          joint_user_relationship: null,
          join_loan: true,
          savings_type: quotation?.savingsType,
          payment_insurance_plan: quotation?.paymentInsurancePlan,
          initial_sum_assured: state.initial_sum_assured || 100000,
          basic_contribution_amount:
            parseFloat(quotation?.basicContributionAmount) || 1000,
          single_contribution_amount:
            parseFloat(quotation?.singleContributionAmount) || 50000,
          intended_commencement_date: getDate_ddmmyyyy(
            state.intended_commencement_date
          ),
          branch_name: state.bank_branch,
          bank_branch_name: state.bank_branch,
          bank_rep_email: state.bank_rep_email,
          bank_rep_contact: state.bank_rep_contact,
          consent_bank_rep: state.consent_bank_rep,
          death_benefit: parseFloat(quotation?.deathBenefit) || 100000,
          tpd_benefit: parseFloat(quotation?.tpdBenefit) || 100000,
          beneficiaries:
            beneficiaries.length > 0
              ? beneficiaries
              : quotation?.quotationFormData?.beneficiaries ||
                quotation?.beneficiaries ||
                [],
        };

        // change field keys
        payload.main_user_maiden_name = payload.maiden_name;
        payload.main_user_passport_number = payload.passport_number;
        payload.main_user_nationality = payload.nationality;

        delete payload.maiden_name;
        delete payload.passport_number;
        delete payload.nationality;

        if (!payload.userJointId) {
          payload.userJointId = null;
        }

        try {
          payload.initial_sum_assured = parseFloat(
            payload.initial_sum_assured.toString()
          );
        } catch (error) {
          console.log(error);
        }
        // delete payload.gender;

        if (payload.bank_branch === "Other") {
          payload.bank_branch = payload.joint_user_financial_institution_branch;
          delete payload.joint_user_financial_institution_branch;
        }

        if (
          !quotation?.quotationFormData?.join_loan &&
          (state.join_loan = true)
        ) {
          // delete payload.isNewJoint;
          payload.isNewJoint = true;
        }

        setLoading(true);
        setError(null);

        const { data } = await axiosPrivate.patch(url, payload);

        setLoading(false);
        setErrors({});
        if (data.success) {
          // Refresh quotation data after successful update
          await getQuotationDetails();
          alert("Quotation updated successfully!");
          navigate(`/quotations/${params.id}`);
        } else {
          setError(
            data.message
              ? data.message
              : "Quotation generation was unsuccessful, please try again"
          );
        }
      } catch (error) {
        //Handing Form Errors
        setLoading(false);
        setError(null);
        console.log(error);
        if (
          error?.response?.data?.errors &&
          error?.response?.data?.errors.length > 0
        ) {
          const errorsFromServer = error.response.data.errors;
          console.error(errorsFromServer);
          let errorData = {};
          if (errorsFromServer.length > 0) {
            errorsFromServer.forEach((err) => {
              if (!errorData[err.field]) {
                errorData[err.field] = [];
              }
              //extra error handling
              errorData[err.field].push(err.message);
            });
          }
          setErrors(errorData);
        } else if (error?.response?.data?.message) {
          setError(error?.response?.data?.message);
        } else {
          //
          setError("Quotation generation was unsuccessful, please try again");
        }
      }
    }
  };

  return (
    <>
      <Navbar
        name={userData ? userData?.data?.firstname?.split(" ")[0] : ""}
        branded={true}
      />

      <GoBack />
      {loading ? (
        <span className="tw-h-full tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center">
          Loading Form...
        </span>
      ) : (
        <main className="container px-lg-4">
          <div className="tw-space-y-0">
            <h1 className="mt-4 tw-font-semibold tw-text-lg">Edit Quotation</h1>
            <p className="">
              Update the desired fields below to edit this quotation.
            </p>
            <span className="text-danger tw-text-sm"> Required Fields *</span>
          </div>

          <div
            className="card border-0 bg-transparent"
            style={{
              borderRadius: 5,
            }}
          >
            <div className=" mt-5">
              <div className="mt-2">
                <div className="forms-sample">
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  {/* Personal Information */}
                  <div className="mb-5">
                    <div className="form-group row mb-3">
                      <label
                        htmlFor="title"
                        className="col-sm-4  col-form-label"
                      >
                        <div>
                          <h1 className="tw-font-semibold tw-text-lg">
                            Personal Information
                          </h1>
                          <p>Enter your personal details to get started</p>
                        </div>
                      </label>

                      <div className="col-sm-8 ">
                        {errors.title && (
                          <div className="invalid-feedback d-block">
                            {errors.title.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                        <div className="form-group row mb-3">
                          <label
                            htmlFor="title"
                            className="tw-text-black col-12 col-form-label ila-form-label"
                          >
                            Title <span className="text-danger">*</span>
                          </label>
                          <div className="col-12">
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, title: "Mr" })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="mrRadio"
                                id="mrRadioNo"
                                checked={state.title === "Mr"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="mrRadioNo"
                              >
                                Mr
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, title: "Ms" })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="msLoanRadio"
                                id="msRadioYes"
                                checked={state.title === "Ms"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="msRadioYes"
                              >
                                Ms
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, title: "Mrs" })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="mrsRadio"
                                id="mrsRadioYes"
                                checked={state.title === "Mrs"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="mrsRadioYes"
                              >
                                Mrs
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, title: "Miss" })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="missRadio"
                                id="missRadioYes"
                                checked={state.title === "Miss"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="missRadioYes"
                              >
                                Miss
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, title: "Dr" })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="drRadio"
                                id="drRadioYes"
                                checked={state.title === "Dr"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="drRadioYes"
                              >
                                Dr
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="firstname"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            First Name <span className="text-danger">*</span>
                          </label>

                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                firstname: event.target.value,
                              });
                            }}
                            value={state.firstname}
                            type="text"
                            className={`col-sm-12 input-control ${
                              errors.firstname && "is-invalid"
                            }`}
                            id="name"
                            placeholder="First Name"
                          />
                          {errors.firstname && (
                            <div className="invalid-feedback d-block">
                              {errors.firstname.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="name"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-12 ">
                            <input
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  lastname: event.target.value,
                                });
                              }}
                              value={state.lastname}
                              type="text"
                              className={`input-control ${
                                errors.lastname && "is-invalid"
                              }`}
                              id="name"
                              placeholder="Last Name"
                            />
                            {errors.lastname && (
                              <div className="invalid-feedback d-block">
                                {errors.lastname.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="nic_date"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Gender <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <select
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  gender: event.target.value,
                                });
                              }}
                              value={state.gender}
                              className={`form-select ${
                                errors.gender && "is-invalid"
                              }`}
                              aria-label="Default select example"
                            >
                              <option value="">Select...</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </select>
                            {errors.gender && (
                              <div className="invalid-feedback d-block">
                                {errors.gender.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="nic_date"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            NIC (National Identity Card){" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <input
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  nic: event.target.value,
                                });
                              }}
                              value={state.nic}
                              type="text"
                              className={`input-control ${
                                errors.nic && "is-invalid"
                              }`}
                              id="nic_date"
                              placeholder="NIC Number"
                            />
                            {errors.nic && (
                              <div className="invalid-feedback d-block">
                                {errors.nic.map((message, index) => {
                                  return (
                                    <div key={index}>
                                      {message.replace("nic", "NIC")}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="birth"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Date of Birth <span className="text-danger">*</span>
                          </label>

                          <DatePicker
                            ref={birthRef}
                            dateFormat="dd/MM/yyyy"
                            placeholder="dd/mm/yyyy"
                            className={`date-control tw-pl-3 ${
                              errors.birth && "is-invalid"
                            }`}
                            selected={state.birth ? state.birth : null}
                            maxDate={new Date(eighteenYearsAgo)}
                            minDate={new Date(sixtyFiveYearsAgo)}
                            id="birth"
                            locale="uk"
                            onChange={(date) =>
                              setState({ ...state, birth: date })
                            }
                          />
                          {errors.birth && (
                            <div className="invalid-feedback d-block">
                              {errors.birth.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="email"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Email <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <input
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  email: event.target.value,
                                });
                              }}
                              value={state.email}
                              type="text"
                              className={`input-control ${
                                errors.email && "is-invalid"
                              }`}
                              id="email"
                              placeholder=""
                            />
                            {errors.email && (
                              <div className="invalid-feedback d-block">
                                {errors.email.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-0">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="phoneNumber"
                            className="tw-whitespace-nowrap col-sm-4 col-form-label ila-form-label"
                          >
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-12">
                            <CustomNumberInput
                              refVal={phoneNumberRef}
                              errors={errors}
                              setState={setState}
                              state={state}
                            />
                            {errors.phoneNumber && (
                              <div className="invalid-feedback d-inline-block">
                                {errors.phoneNumber.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-lg-6 mb-3">
                          <label
                            htmlFor="phoneNumber"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Whatsapp Number
                          </label>
                          <div className="col-sm-12">
                            <WhatsappNumberInput
                              refVal={whatsappNumberRef}
                              errors={{}}
                              state={state}
                              setState={setState}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*NEW FIELDS*/}
                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="maiden_name"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Maiden Name
                          </label>

                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                maiden_name: event.target.value,
                              });
                            }}
                            value={state.maiden_name}
                            type="text"
                            className={`input-control ${
                              errors.maiden_name && "is-invalid"
                            }`}
                            id="maiden_name"
                            placeholder="Maiden Name"
                          />
                          {errors.maiden_name && (
                            <div className="invalid-feedback d-block">
                              {errors.maiden_name.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="passport_number"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            Passport Number{" "}
                          </label>

                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                passport_number: event.target.value,
                              });
                            }}
                            value={state.passport_number}
                            type="text"
                            className={`input-control ${
                              errors.passport_number && "is-invalid"
                            }`}
                            id="passport_number"
                            placeholder="Passport Number"
                          />
                          {errors.passport_number && (
                            <div className="invalid-feedback d-block">
                              {errors.passport_number.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="nationality"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Nationality <span className="text-danger">*</span>
                          </label>

                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                nationality: event.target.value,
                              });
                            }}
                            value={state.nationality}
                            type="text"
                            className={`input-control ${
                              errors.nationality && "is-invalid"
                            }`}
                            id="nationality"
                            placeholder="Nationality"
                          />
                          {errors.nationality && (
                            <div className="invalid-feedback d-block">
                              {errors.nationality.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="name"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            Joint Policy <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, join_loan: false })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="joinLoanRadio"
                                id="joinLoanRadioNo1"
                                checked={!state.join_loan}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="joinLoanRadioNo1"
                              >
                                No
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, join_loan: true })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="joinLoanRadio"
                                id="joinLoanRadioYes1"
                                checked={state.join_loan}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="joinLoanRadioYes1"
                              >
                                Yes
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* NEW FIELDS */}
                  </div>
                  {/* End Personal Information */}

                  {state.join_loan && (
                    <>
                      {/* Joint Life Information */}
                      <section className="tw-py-8">
                        <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                      </section>
                      <div className="my-5">
                        <div className="form-group row mb-3">
                          <label
                            htmlFor="title"
                            className="col-sm-4 col-form-label"
                          >
                            <div>
                              <h1 className="tw-font-semibold tw-text-lg">
                                Joint Life Information
                              </h1>
                              <p>Enter details to set up your Joint Life.</p>
                            </div>
                          </label>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="firstname"
                                className="col-sm-12  col-form-label ila-form-label"
                              >
                                Phone Number for Joint Life{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <CustomNumberInput
                                  refVal={jointLifephoneNumberRef}
                                  errors={{}}
                                  state={state}
                                  setState={setState}
                                  fieldName="joint_user_phoneNumber"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-0">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 ">
                            <div className="form-group row mb-3">
                              <label
                                htmlFor="title"
                                className="col-12  col-form-label ila-form-label"
                              >
                                Title for Joint Life{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="col-12">
                                <div
                                  className="form-check form-check-inline"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      joint_user_title: "Mr",
                                    })
                                  }
                                >
                                  <input
                                    readOnly
                                    className="form-check-input"
                                    type="radio"
                                    name="mrRadioJointLife"
                                    id="mrRadioJointLife"
                                    checked={state.joint_user_title === "Mr"}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="mrRadioJointLife"
                                  >
                                    Mr
                                  </label>
                                </div>
                                <div
                                  className="form-check form-check-inline"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      joint_user_title: "Ms",
                                    })
                                  }
                                >
                                  <input
                                    readOnly
                                    className="form-check-input"
                                    type="radio"
                                    name="msLoanRadioJointLife"
                                    id="msLoanRadioJointLife"
                                    checked={state.joint_user_title === "Ms"}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="msLoanRadioJointLife"
                                  >
                                    Ms
                                  </label>
                                </div>
                                <div
                                  className="form-check form-check-inline"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      joint_user_title: "Mrs",
                                    })
                                  }
                                >
                                  <input
                                    readOnly
                                    className="form-check-input"
                                    type="radio"
                                    name="mrsRadioJointLife"
                                    id="mrsRadioJointLife"
                                    checked={state.joint_user_title === "Mrs"}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="mrsRadioJointLife"
                                  >
                                    Mrs
                                  </label>
                                </div>
                                <div
                                  className="form-check form-check-inline"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      joint_user_title: "Miss",
                                    })
                                  }
                                >
                                  <input
                                    readOnly
                                    className="form-check-input"
                                    type="radio"
                                    name="missRadioJointLife"
                                    id="missRadioJointLife"
                                    checked={state.joint_user_title === "Miss"}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="missRadioJointLife"
                                  >
                                    Miss
                                  </label>
                                </div>
                                <div
                                  className="form-check form-check-inline"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      joint_user_title: "Dr",
                                    })
                                  }
                                >
                                  <input
                                    readOnly
                                    className="form-check-input"
                                    type="radio"
                                    name="drRadioJointLife"
                                    id="drRadioJointLife"
                                    checked={state.joint_user_title === "Dr"}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="drRadioJointLife"
                                  >
                                    Dr
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-3">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_firstname"
                                className="col-sm-12  col-form-label ila-form-label"
                              >
                                First Name{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <input
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_firstname: event.target.value,
                                  });
                                }}
                                value={state.joint_user_firstname}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_firstname && "is-invalid"
                                }`}
                                id="name"
                                placeholder="First Names"
                              />
                              {errors.joint_user_firstname && (
                                <div className="invalid-feedback d-block">
                                  {errors.joint_user_firstname.map(
                                    (message, index) => {
                                      return <div key={index}>{message}</div>;
                                    }
                                  )}
                                </div>
                              )}
                            </div>

                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_lastname"
                                className="col-sm-12  col-form-label ila-form-label"
                              >
                                Last name <span className="text-danger">*</span>
                              </label>
                              <div className="col-sm-12 ">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_lastname: event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_lastname}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_lastname && "is-invalid"
                                  }`}
                                  id="name"
                                  placeholder="Last Name"
                                />
                                {errors.joint_user_lastname && (
                                  <div className="invalid-feedback d-block">
                                    {errors.joint_user_lastname.map(
                                      (message, index) => {
                                        return <div key={index}>{message}</div>;
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-3">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_birth"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Date of Birth{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <DatePicker
                                  ref={otherBirthRef}
                                  dateFormat="dd/MM/yyyy"
                                  className={`input-control ${
                                    errors.joint_user_birth && "is-invalid"
                                  }`}
                                  selected={
                                    state.joint_user_birth
                                      ? state.joint_user_birth
                                      : null
                                  }
                                  maxDate={new Date(eighteenYearsAgo)}
                                  minDate={new Date(sixtyFiveYearsAgo)}
                                  id="joint_user_birth"
                                  locale="uk"
                                  onChange={(date) =>
                                    setState({
                                      ...state,
                                      joint_user_birth: date,
                                    })
                                  }
                                />
                                {errors.birth && (
                                  <div className="invalid-feedback d-block">
                                    {errors.birth.map((message, index) => {
                                      return <div key={index}>{message}</div>;
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="name"
                                className="col-sm-12  col-form-label ila-form-label"
                              >
                                NIC <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_nic: event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_nic}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_nic && "is-invalid"
                                  }`}
                                  id="nic_date"
                                  placeholder="National Identity Card Number"
                                />
                                {errors.joint_user_nic && (
                                  <div className="invalid-feedback d-block">
                                    {errors.joint_user_nic.map(
                                      (message, index) => {
                                        return (
                                          <div key={index}>
                                            {message.replace("nic_date", "NIC")}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-3">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="email"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Email for Joint Life{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_email: event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_email}
                                  type="text"
                                  className={`input-control ${
                                    errors.name && "is-invalid"
                                  }`}
                                  id="name"
                                  placeholder="Email for Joint Life"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="gender"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Gender <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <select
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_gender: event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_gender}
                                  className={`form-select ${
                                    errors.joint_user_gender && "is-invalid"
                                  }`}
                                  aria-label="Default select example"
                                >
                                  <option value="">Select...</option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                </select>
                                {errors.joint_user_gender && (
                                  <div className="invalid-feedback d-block">
                                    {errors.joint_user_gender.map(
                                      (message, index) => {
                                        return <div key={index}>{message}</div>;
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-3">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_maiden_name"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Maiden Name
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_maiden_name:
                                        event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_maiden_name}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_maiden_name &&
                                    "is-invalid"
                                  }`}
                                  id="joint_user_maiden_name"
                                  placeholder="Joint User Maiden Name"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_passport_number"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Passport Number{" "}
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_passport_number:
                                        event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_passport_number}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_passport_number &&
                                    "is-invalid"
                                  }`}
                                  id="joint_user_passport_number"
                                  placeholder="Joint User Passport Number"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row mb-3">
                          <div className="col-sm-4"></div>
                          <div className="col-sm-8 row">
                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_nationality"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Nationality{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_nationality:
                                        event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_nationality}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_nationality &&
                                    "is-invalid"
                                  }`}
                                  id="joint_user_nationality"
                                  placeholder="Joint User Nationality"
                                />
                              </div>
                            </div>

                            <div className="col-12 col-lg-6">
                              <label
                                htmlFor="joint_user_relationship"
                                className="col-sm-12 col-form-label ila-form-label"
                              >
                                Relationship{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="col-sm-12">
                                <input
                                  onChange={(event) => {
                                    setState({
                                      ...state,
                                      joint_user_relationship:
                                        event.target.value,
                                    });
                                  }}
                                  value={state.joint_user_relationship}
                                  type="text"
                                  className={`input-control ${
                                    errors.joint_user_relationship &&
                                    "is-invalid"
                                  }`}
                                  id="joint_user_relationship"
                                  placeholder="Joint User Relationship"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* End Joint Life */}
                    </>
                  )}

                  <section className="tw-py-8">
                    <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                  </section>

                  {/* Add Beneficiary */}
                  <section className="tw-py-8">
                    <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                  </section>

                  <div className="my-5">
                    <div className="form-group row mb-3">
                      <label
                        htmlFor="title"
                        className="col-sm-4 col-form-label"
                      >
                        <div>
                          <span className="tw-font-semibold">
                            Beneficiary Or Bank Details
                          </span>
                          <p>
                            Select either Bank or Beneficiary details to
                            complete your policy setup.
                          </p>
                        </div>
                      </label>
                      <div className="col-sm-8 tw-space-y-4">
                        <div className="col-12 col-lg-7">
                          <label
                            htmlFor="firstname"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Intended Commencement Date{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <DatePicker
                              ref={intendedCommencementDateRef}
                              dateFormat="dd/MM/yyyy"
                              className={`input-control ${
                                errors.intended_commencement_date &&
                                "is-invalid"
                              }`}
                              selected={
                                state.intended_commencement_date
                                  ? state.intended_commencement_date
                                  : null
                              }
                              maxDate={new Date(fifteenDaysFromToday)}
                              minDate={new Date(today)}
                              id="intended_commencement_date"
                              locale="uk"
                              onChange={(date) =>
                                setState({
                                  ...state,
                                  intended_commencement_date: date,
                                })
                              }
                            />
                            {errors.intended_commencement_date && (
                              <div className="invalid-feedback d-block">
                                {errors.intended_commencement_date.map(
                                  (message, index) => {
                                    return <div key={index}>{message}</div>;
                                  }
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-grow tw-flex-wrap tw-items-start md:tw-items-center tw-gap-2">
                          {benefitsToggle.map((tog) => {
                            const hasBankData =
                              state.initial_sum_assured &&
                              state.bank_name &&
                              state.bank_branch;

                            const hasBeneficiaryData = beneficiaries.some(
                              (b) =>
                                b.fullname ||
                                parseFloat(b.percentage) ||
                                b.nic ||
                                b.relationship
                            );

                            let isDisabled = false;
                            if (tog.id == 0) {
                              isDisabled = hasBankData;
                            }
                            if (tog.id == 1) {
                              isDisabled = hasBeneficiaryData;
                            }

                            return (
                              <div
                                key={tog.id}
                                onClick={() =>
                                  !isDisabled && handleAddBenefit(tog.id)
                                }
                                className={`tw-bg-transparent tw-rounded-lg tw-w-fit tw-h-[3.2rem] tw-px-4 tw-border tw-border-black/20 tw-flex tw-items-center tw-gap-2 ${
                                  isDisabled
                                    ? "tw-cursor-not-allowed"
                                    : "tw-cursor-pointer"
                                } ${
                                  activeBenefit === tog.id
                                    ? "!tw-bg-[#BEC663]/10"
                                    : ""
                                }`}
                              >
                                <IoCheckmark
                                  className={`tw-bg-transparent tw-rounded-full tw-w-5 tw-h-5 tw-p-1 tw-text-white ${
                                    activeBenefit === tog.id
                                      ? "!tw-bg-[#BEC663]"
                                      : "tw-border tw-border-black/50"
                                  } ${isDisabled ? "tw-opacity-50" : ""}`}
                                />
                                <img
                                  className="tw-w-[30px] tw-object-contain"
                                  alt={tog.title}
                                  src={tog.icon}
                                />
                                <span
                                  className={isDisabled ? "tw-opacity-50" : ""}
                                >
                                  {tog.title}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  {activeBenefit === 0 && (
                    <>
                      <section className="tw-py-8">
                        <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                      </section>
                      <section className="form-group row mb-3">
                        <label
                          htmlFor="title"
                          className="col-sm-4 col-form-label"
                        >
                          <div>
                            <span className="tw-font-semibold">
                              Add Beneficiary
                            </span>
                            <p>
                              Enter beneficiary details and assign their
                              percentage.
                            </p>
                          </div>
                        </label>

                        <div className="tw-w-full col-sm-8 row">
                          <div className="col-sm-4"></div>
                          {beneficiaries.map((beneficiary, index) => (
                            <div
                              key={index}
                              className={` ${index > 0 && "mb-4"} `}
                            >
                              <div className={` ${index > 0 && "tw-py-6"} `}>
                                <div
                                  className={` ${
                                    index > 0 ? "tw-flex" : "tw-hidden"
                                  } tw-border-b tw-w-full tw-border-black/10`}
                                ></div>
                              </div>
                              <span className="tw-bg-[#BEC663] tw-rounded-full tw-w-10 tw-h-10 tw-p-2 tw-text-white tw-grid tw-place-items-center">
                                {index + 1}
                              </span>
                              <div className="row">
                                <div className="col-sm-8 row"></div>
                                <div className="col-12 col-lg-6">
                                  <label className="col-sm-12 col-form-label ila-form-label">
                                    Beneficiary Full Name
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`input-control ${
                                      beneficiaryErrors[index]?.fullname &&
                                      "is-invalid"
                                    }`}
                                    value={beneficiary.fullname}
                                    onChange={(e) =>
                                      handleBeneficiaryChange(
                                        index,
                                        "fullname",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Full Name"
                                    disabled={
                                      parseFloat(beneficiary.percentage) === 0
                                    }
                                  />
                                  {beneficiaryErrors[index]?.fullname && (
                                    <div className="invalid-feedback">
                                      {beneficiaryErrors[index].fullname}
                                    </div>
                                  )}
                                </div>

                                <div className="col-12 col-lg-6">
                                  <label className="col-sm-12 col-form-label ila-form-label">
                                    Percentage Allocation
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className={`input-control ${
                                        beneficiaryErrors[index]?.percentage &&
                                        "is-invalid"
                                      }`}
                                      value={beneficiary.percentage}
                                      onChange={(e) =>
                                        handleBeneficiaryChange(
                                          index,
                                          "percentage",
                                          e.target.value
                                        )
                                      }
                                      placeholder="%"
                                      min="0"
                                      max="100"
                                      step="1"
                                    />
                                    {/* <span className="input-group-text">%</span> */}
                                    {beneficiaryErrors[index]?.percentage && (
                                      <div className="invalid-feedback">
                                        {beneficiaryErrors[index].percentage}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12 col-lg-6">
                                  <label className="col-sm-12 col-form-label ila-form-label">
                                    NIC (National Identity Card)
                                  </label>
                                  <input
                                    type="text"
                                    className={`input-control ${
                                      beneficiaryErrors[index]?.nic &&
                                      "is-invalid"
                                    }`}
                                    value={beneficiary.nic}
                                    onChange={(e) =>
                                      handleBeneficiaryChange(
                                        index,
                                        "nic",
                                        e.target.value
                                      )
                                    }
                                    placeholder="NIC"
                                    disabled={
                                      parseFloat(beneficiary.percentage) === 0
                                    }
                                  />
                                  {beneficiaryErrors[index]?.nic && (
                                    <div className="invalid-feedback">
                                      {beneficiaryErrors[index].nic}
                                    </div>
                                  )}
                                </div>
                                <div className="col-12 col-lg-6">
                                  <label className="col-sm-12 col-form-label ila-form-label">
                                    Relationship
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`input-control ${
                                      beneficiaryErrors[index]?.relationship &&
                                      "is-invalid"
                                    }`}
                                    value={beneficiary.relationship}
                                    onChange={(e) =>
                                      handleBeneficiaryChange(
                                        index,
                                        "relationship",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Relationship"
                                    disabled={
                                      parseFloat(beneficiary.percentage) === 0
                                    }
                                  />
                                  {beneficiaryErrors[index]?.relationship && (
                                    <div className="invalid-feedback">
                                      {beneficiaryErrors[index].relationship}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="tw-my-4">
                                <div className="tw-flex tw-flex-end tw-justify-self-end">
                                  <button
                                    type="button"
                                    className="tw-bg-transaprent tw-border tw-border-[#BEC663] tw-rounded-md tw-w-fit tw-h-10 tw-px-3 tw-text-[#BEC663] tw-font-semibold tw-text-sm"
                                    onClick={() => removeBeneficiary(index)}
                                  >
                                    {beneficiaries.length === 1
                                      ? "Clear"
                                      : "Remove"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}

                          <div className="tw-w-full mb-3">
                            <div className="!tw-bg-[#CFF4FC] tw-w-full tw-h-auto tw-rounded-lg tw-p-4 tw-text-[#135C6B]">
                              <span className="tw-font-semibold">
                                Total Allocation:
                              </span>{" "}
                              {totalAllocated}%
                              {totalAllocated !== 100 && (
                                <span>
                                  {" "}
                                  - Please distribute 100% among beneficiaries
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="tw-w-full tw-flex tw-justify-end">
                            <button
                              type="button"
                              className={` ${
                                totalAllocated >= 100
                                  ? " tw-py-2 tw-px-4 tw-w-auto tw-h-auto tw-rounded-lg tw-cursor-not-allowed"
                                  : ""
                              } tw-whitespace-nowrap tw-flex tw-items-center tw-gap-x-2 tw-bg-[#BEC663]/10 tw-border tw-border-[#BEC663] tw-text-black/50 tw-p-3 tw-rounded-md`}
                              onClick={addBeneficiary}
                              disabled={totalAllocated >= 100}
                            >
                              <PlusIcon className="tw-bg-[#BEC663] tw-text-white tw-rounded-full tw-w-4 tw-h-4" />
                              <span>Add New Beneficiary</span>
                            </button>
                          </div>
                        </div>
                      </section>
                    </>
                  )}

                  {activeBenefit === 1 && (
                    <div className="my-5">
                      <section className="tw-py-8">
                        <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                      </section>
                      <div className="form-group row mb-3">
                        <label
                          htmlFor="title"
                          className="col-sm-4  col-form-label"
                        >
                          <div>
                            <span className="tw-font-semibold">
                              Enter Bank Details
                            </span>
                            <p>
                              Provide your bank information for the policy
                              payout.
                            </p>
                          </div>
                        </label>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="sum-assured"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Sum Assured <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <CurrencyInput
                                className={`input-control ${
                                  errors.initial_sum_assured && "is-invalid"
                                }`}
                                onValueChange={(event) => {
                                  setState({
                                    ...state,
                                    initial_sum_assured: event,
                                  });
                                }}
                                prefix="Rs "
                                value={state.initial_sum_assured}
                                placeholder="Sum Assured"
                              />

                              {errors.initial_sum_assured && (
                                <div className="invalid-feedback d-block">
                                  {errors.initial_sum_assured.map(
                                    (message, index) => {
                                      return <div key={index}>{message}</div>;
                                    }
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="firstname"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Financial Institution{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <select
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    bank_name: event.target.value,
                                  });
                                  setBankBranches(
                                    getBranchesForBank(event.target.value)
                                  );
                                }}
                                value={state.bank_name}
                                className={`form-select ${
                                  errors.bank_name && "is-invalid"
                                }`}
                                aria-label="Default select example"
                              >
                                <option value="">Select...</option>
                                {banks &&
                                  banks.map((bank, index) => {
                                    return (
                                      <option value={bank.name} key={index}>
                                        {bank.name}
                                      </option>
                                    );
                                  })}
                              </select>
                              {errors.bank_name && (
                                <div className="invalid-feedback d-block">
                                  {errors.bank_name.map((message, index) => {
                                    return <div key={index}>{message}</div>;
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="name"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              Financial Institution Branch{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <select
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    bank_branch: event.target.value,
                                  });
                                }}
                                value={state.bank_branch}
                                className={`form-select ${
                                  errors.bank_branch && "is-invalid"
                                }`}
                                aria-label="Default select example"
                              >
                                <option value="">Select...</option>
                                {banks && (
                                  <>
                                    {bankBranches.map((branch, index) => {
                                      return (
                                        <option
                                          value={
                                            branch.name + "-" + branch.town
                                          }
                                          key={index}
                                        >
                                          <div>
                                            <div>
                                              {branch.name} - {branch.town}
                                            </div>
                                          </div>
                                        </option>
                                      );
                                    })}
                                  </>
                                )}
                                <option value="Other">Other</option>
                              </select>

                              {state.bank_branch === "Other" && (
                                <div className="form-group row mb-3">
                                  <label
                                    htmlFor="joint_user_financial_institution_branch"
                                    className="col-sm-12 mt-2 col-form-label"
                                  >
                                    Please Specify Branch{" "}
                                  </label>
                                  <div className="col-sm-12 ">
                                    <input
                                      onChange={(event) => {
                                        setState({
                                          ...state,
                                          joint_user_financial_institution_branch:
                                            event.target.value,
                                        });
                                      }}
                                      value={
                                        state.joint_user_financial_institution_branch
                                      }
                                      type="text"
                                      className={`input-control `}
                                      id="joint_user_financial_institution_branch"
                                      placeholder="Financial Institution Branch"
                                    />
                                  </div>
                                </div>
                              )}

                              {errors.bank_branch && (
                                <div className="invalid-feedback d-block">
                                  {errors.bank_branch.map((message, index) => {
                                    return <div key={index}>{message}</div>;
                                  })}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="bank_rep_name"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Bank Representative Name
                            </label>

                            <div className="col-sm-12">
                              <input
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    bank_rep_name: event.target.value,
                                  });
                                }}
                                value={state.bank_rep_name}
                                type="text"
                                className={`input-control `}
                                id="bank_rep_name"
                                placeholder="Bank Rep Name"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="name"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              Bank Representative Email
                            </label>

                            <div className="col-sm-12">
                              <input
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    bank_rep_email: event.target.value,
                                  });
                                }}
                                value={state.bank_rep_email}
                                type="text"
                                className={`input-control `}
                                id="bank_rep_email"
                                placeholder="Bank Rep Email"
                              />
                            </div>
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="name"
                              className="tw-text-black/50 col-sm-12"
                            >
                              Do you consent to ILA sending your Policy
                              Documents to your designated Bank Representative?
                            </label>

                            <div className="col-sm-12">
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  setState({
                                    ...state,
                                    consent_bank_rep: false,
                                  })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  name="bankRepConsentRadio"
                                  id="bankRepConsentRadioNo"
                                  checked={!state.consent_bank_rep}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="bankRepConsentRadioNo"
                                >
                                  No
                                </label>
                              </div>
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  setState({ ...state, consent_bank_rep: true })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  name="bankRepConsentRadio"
                                  id="bankRepConsentRadioYes"
                                  checked={state.consent_bank_rep}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="bankRepConsentRadioYes"
                                >
                                  Yes
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="bank_rep_name"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Bank Representative Contact
                            </label>

                            <div className="col-sm-12">
                              <CustomNumberInput
                                refVal={bankRepContactRef}
                                errors={{}}
                                state={state}
                                setState={setState}
                                fieldName="bank_rep_contact"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="tw-w-full tw-flex tw-justify-end tw-mt-4">
                        <button
                          type="button"
                          onClick={clearBankDetails}
                          className="tw-bg-transparent tw-border tw-border-[#BEC663] tw-rounded-md tw-w-fit tw-h-10 tw-px-3 tw-text-[#BEC663] tw-font-semibold tw-text-sm"
                        >
                          Clear Bank Details
                        </button>
                      </div>
                    </div>
                  )}

                  {/* End Add Beneficiary */}

                  <div className="d-flex justify-content-end">
                    <button
                      onClick={() => {
                        submitData();
                      }}
                      type="button"
                      className="btn submit-btn me-2 mb-3"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}{" "}
                      Edit Quotation
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default FlexiEditQuotation;
